import { cva } from "class-variance-authority"

import { cn } from "../../helpers"
import { paragraph } from "../typography"

const baseInputClassName = cn(
  "flex w-full bg-white transition-[color,box-shadow] outline-none cursor-text items-center gap-3",
  paragraph({ size: "sm" }),
  "disabled:cursor-not-allowed",
)

const inputVariants = cva(baseInputClassName, {
  variants: {
    size: {
      default: "px-4 py-3.5 rounded-xl",
    },
    variant: {
      default: [
        "ring-1 ring-neutral-200",
        "hover:ring-offset-2 hover:ring-4 hover:ring-neutral-100 hover:ring-offset-neutral-300",
        "focus-within:ring-offset-2 focus-within:ring-4 focus-within:ring-blurple-100 focus-within:ring-offset-blurple-500",
        "focus-within:hover:ring-offset-2 focus-within:hover:ring-4 focus-within:hover:ring-blurple-100 focus-within:hover:ring-offset-blurple-500",
      ],
      error: [
        "ring-1 ring-red-200",
        "hover:ring-offset-2 hover:ring-4 hover:ring-red-100 hover:ring-offset-red-300",
        "focus-within:ring-offset-2 focus-within:ring-4 focus-within:ring-red-100 focus-within:ring-offset-red-700",
        "focus-within:hover:ring-offset-2 focus-within:hover:ring-4 focus-within:hover:ring-red-100 focus-within:hover:ring-offset-red-700",
      ],
    },
    disabled: {
      false: "",
      true: "",
    },
  },
  defaultVariants: {
    disabled: false,
    size: "default",
    variant: "default",
  },
  compoundVariants: [
    {
      disabled: true,
      variant: ["default", "error"],
      className:
        "opacity-50 cursor-not-allowed ring-1 ring-neutral-200 hover:ring-1 hover:ring-neutral-200 focus-within:ring-0 hover:ring-offset-0 focus-within:ring-offset-0 bg-neutral-50",
    },
  ],
})

const wrapper = (className?: string) => cn("flex flex-col gap-2 ", className)
const basicInput = cn(
  "w-full rounded-none border-none bg-transparent outline-none placeholder:text-neutral-600 text-base ",
)

export { basicInput, inputVariants, wrapper }
